import { Component, Emit, Vue, Prop, Watch } from 'vue-property-decorator';
import * as api from '@/api';
import * as models from '@/api/models';

export type BaseType = 'secondary' | 'danger' | 'warning';

/** userid -> userName */
@Component({})
export default class TextComponent extends Vue {
  @Prop() type?: BaseType;
  @Prop() block?: boolean;

  mounted() {}

  render() {
    const css: string[] = ['c-text'];
    this.type && css.push(this.type as any);
    this.block !== undefined && css.push('block');
    return <span class={css}>{this.$slots.default}</span>;
  }
}
